import React from 'react';
import { CheckCircle2Icon, ZapIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const items = ['10 print-ready volumes (600 pages)', 'Theory, activities and speaking tasks for every unit', 'Assessments, rubrics and answer keys', '3 projects (trabajos prácticos) per volume', 'Final exams and progress certificates', 'The complete cheat-sheets and course maps'];
export function InstantAccessSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-28" data-id="element-96" data-mp="1wb5e6gnfjxg3">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-97" data-mp="1reoqtoo21n42">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-brand-orange/15 text-brand-orange" data-id="element-98" data-mp="1rg86pe5stw5b">
          <ZapIcon className="h-6 w-6" aria-hidden="true" data-id="element-99" data-mp="20e246sfauvu2" />
        </div>
        <h2 className="mb-12 text-3xl font-black text-brand-blue md:text-4xl" data-id="element-100" data-mp="aznhednudj17">
          ⚡ What Do You Get Instantly?
        </h2>
        <div className="space-y-3 text-left" data-id="element-101" data-mp="61c8c55dfck1">
          {items.map(item => <div key={item} className="flex items-center gap-4 rounded-2xl border border-brand-dark bg-brand-alt p-5 shadow-sm" data-id="element-102" data-mp="2n1x77o1ri7wq">
              <CheckCircle2Icon className="h-6 w-6 shrink-0 text-brand-teal" aria-hidden="true" data-id="element-103" data-mp="2rynmwa9nn1hm" />
              <span className="font-semibold" data-id="element-104" data-mp="31qtal7sviwr0">{item}</span>
            </div>)}
        </div>
        <p className="mt-10 font-serif text-2xl font-bold italic text-brand-purple" data-id="element-105" data-mp="35sy13xo0zd9f">
          You never run out of material.
        </p>
      </Reveal>
    </section>;
}